var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-container" },
    [
      _c("desktop-nav", {
        staticClass: "nav-desktop hide-sm hide-md",
        attrs: {
          "menu-data": _vm.menuData,
          "profile-link": _vm.profileLink,
          "header-links": _vm.headerLinks
        },
        on: { signup: _vm.showSignupSlider }
      }),
      _vm._v(" "),
      _c(
        "slider",
        {
          ref: "navSlider",
          staticClass: "nav-slider",
          attrs: {
            "close-button": false,
            side: "left",
            "header-color": "#267d5f",
            top: 55,
            "pixel-width": 275
          },
          model: {
            value: _vm.navData.slider,
            callback: function($$v) {
              _vm.$set(_vm.navData, "slider", $$v)
            },
            expression: "navData.slider"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "nav-slider-head horizontal bottom between",
              class: { "logged-in": _vm.loggedIn },
              attrs: { slot: "head" },
              slot: "head"
            },
            [
              _vm.loggedIn
                ? [
                    _c(
                      "f9link",
                      {
                        staticClass: "vertical center left",
                        attrs: {
                          href: _vm.ibeHost() + "/FrontierMiles/Profile",
                          nostyle: ""
                        }
                      },
                      [
                        _c("span", { staticClass: "member-name" }, [
                          _vm._v(
                            "Hi, " +
                              _vm._s(_vm.member.firstName) +
                              " | " +
                              _vm._s(_vm.member.currentMiles) +
                              " mi."
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", [_vm._v("FRONTIER Miles")]),
                          _c("span", { staticClass: "sm" }, [_vm._v("sm")]),
                          _vm._v(" Profile")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "f9button",
                      { attrs: { nostyle: "" }, on: { click: _vm.logout } },
                      [_vm._v("Logout")]
                    )
                  ]
                : [
                    _c("span", { staticClass: "nav-my-frontier" }, [
                      _c("i", [_vm._v("FRONTIER Miles")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "f9button",
                      {
                        staticClass: "nav-signup",
                        attrs: { nostyle: "" },
                        on: { click: _vm.signup }
                      },
                      [_vm._v("Sign up today!")]
                    )
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c("mobile-nav", {
            attrs: {
              "menu-data": _vm.menuData,
              "profile-link": _vm.profileLink,
              "header-links": _vm.headerLinks
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07cd4ffd", { render: render, staticRenderFns: staticRenderFns })
  }
}